module.exports = {"441324001":"龙城街道","441324002":"平陵街道","441324100":"麻榨镇","441324101":"永汉镇","441324115":"龙田镇","441324116":"龙潭镇","441324117":"地派镇","441324118":"龙华镇","441324119":"龙江镇","441324200":"蓝田瑶族乡","441324453":"龙门县密溪林场","441324570":"南昆山生态旅游区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441324.json
// module id = 2023
// module chunks = 0